import { DaDataResponse, RawCompanyData, UserCompany } from '@company/const';
import { StateUtils } from '@spartacus/core';

export const COMPANY_FEATURE = 'company';
export const SEARCH_COMPANY_ENTITY = '[Company] Search Company Entity';
export const ADD_COMPANY_ENTITY = '[Company] Add Company Entity';
export const REMOVE_COMPANY_ENTITY = '[Company] Remove Company Entity';
export const USER_COMPANIES_ENTITY = '[Company] User Companies Entity';

export interface CompanyState {
  search: StateUtils.LoaderState<DaDataResponse[]>;
  add: StateUtils.LoaderState<string>;
  remove: StateUtils.LoaderState<string>;
  selected: string;
  saved: RawCompanyData;
  userCompanies: StateUtils.LoaderState<UserCompany[]>;
}

export interface StateWithCompany {
  [COMPANY_FEATURE]: CompanyState;
}
